import numberToWord from '../modules/numberToWord';

export default {
    create(params) {
        const player = {
            index: 0,
            firstName: this.defaultPlayerName(),
            lastName: numberToWord(params.generalIndex + 1),
            phoneCountryCode: null,
            phoneNumber: null,
            email: null,
            youngAdult: false,
            member: false,
            mainBooker: false,
            defaultNameState: true,
            defaults: {
                firstName: this.defaultPlayerName(),
                lastName: numberToWord(params.generalIndex + 1),
            },
        };

        if (!params) {
            return player;
        }

        // Merge objects using ES6 array seperator.
        // https://davidwalsh.name/merge-objects.
        return { ...player, ...params };
    },

    defaultPlayerName() {
        if (!window.appLocale || window.appLocale === 'en-150') {
            return 'Player';
        }

        return 'Speler';
    },
};
